import React, { useEffect, useState } from 'react';
import { Card, Button, Container } from 'react-bootstrap';

const Home = () => {
    const [message, setMessage] = useState('');

    // Fetch the message from the backend API
    const fetchMessageFromServer = () => {
        fetch('/api/message')
            .then((response) => response.json())
            .then((data) => {
                setMessage(data.message);
            });
    };

    // Load data from the server when the component is first rendered
    useEffect(() => {
        fetchMessageFromServer();
    }, []);

    // Handle button click
    const handleClick = () => {
        setMessage('Hello, React!'); // Show custom text
        setTimeout(() => {
            fetchMessageFromServer(); // Fetch data again from the server
        }, 2000); // Optional delay
    };

    return (
        <Container className="mt-5">
            <Card className="text-center">
                <Card.Header>Welcome</Card.Header>
                <Card.Body>
                    <Card.Title>Message from the Backend</Card.Title>
                    <Card.Text>{message}</Card.Text>
                    <Button variant="primary" onClick={handleClick}>Click Me!</Button>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Home;
